var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmTickStep = function SvgConfirmTickStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.027,
    height: 21.027,
    x: 0.486,
    y: 0.486,
    fill: "#32D583",
    rx: 10.514
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.027,
    height: 21.027,
    x: 0.486,
    y: 0.486,
    stroke: "#fff",
    strokeWidth: 0.973,
    rx: 10.514
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.048,
    d: "m6.336 11.349 3.26 3.143 6.517-6.286"
  })));
};
export default SvgConfirmTickStep;